'use client'

import type { InputLabelProps as MuiInputLabelProps } from '@mui/material/InputLabel'

import InputLabel from '@mui/material/InputLabel'

import { styled } from '@mui/material/styles'

type InputLabelProps = MuiInputLabelProps
const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  '&.MuiInputLabel-root': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizes.spacing['03'],
    position: 'relative',
    color: theme.colors.text.secondary,
    fontFamily: theme.fonts.family.body,
    fontStyle: 'normal',
    fontWeight: theme.fonts.weight.medium,
    lineHeight: theme.fonts.lineHeight['leading-4'],
    fontSize: theme.fonts.size.sm,
    letterSpacing: theme.fonts.letterSpacing.wider,
  },
}))

export default StyledInputLabel
export type { InputLabelProps }
